import * as React from 'react';
import { UIComponentHandler } from '../../../toolkit/uicomponent';
import { BaseContext } from '../../../../utils/basecontext';
import { GenericTabViewModel, GenericTabViewModelImpl } from '../../../toolkit/tabs/generictabviewmodel';
import { GenericTabComponent } from '../../../toolkit/tabs/generictabcomponent';
import { TunesComponentProps, TunesTabComponentHandler, TunesComponentHandler, TunesComponentState } from './tunescomponent';
import { Strings } from '../../../../utils/resources/strings';
import { TabViewModelImpl } from '../../../toolkit/tabs/tab/tabviewmodel';
import { ToneDto } from '../../../../core/dto/tonedto';
import { CRBTUIViewImpl } from '../crbt/crbtuiview';
import { TunesToneViewModelImpl } from './tones/tunestoneviewmodel';
import { TunesCSSStyle } from './tunescss';
// import { PlaylistToneViewModelHandler, PlaylistToneViewModelImpl } from '../mytunes/playlist/playlistcard/playlistviewmodel';
// import { PlayListTabViewModelImpl } from '../mytunes/playlist/playlisttabviewmodel';
// import { PlaylistTunesTabViewModelImpl } from './playlist/playlisttabviewmodel';
import { ToneRowOptionsPrivilageImpl } from '../../../toolkit/toneoptions/tone/tonerowcomponent';
import { ListTonesComponent } from '../listtone/listtonecomponent';
import { TunesListTabViewModelImpl } from './tuneslisttabviewmodel';
import { ListTonesDto } from 'src/com/sixdee/crbtportal/core/dto/listtones/listtonesdto';
import { LoaderWrapperComponent } from '../../popup/loaderwrappercomponent';
import { LoaderComponent } from '../../../toolkit/loader/loadercomponent';
import { PopUpWrapperComponent } from '../../popup/popupwrappercomponent';
import { AlertType } from '../../../toolkit/alert/alerttype';
import { AlertComponent } from '../../../toolkit/alert/alertcomponent';
import { RoutingFeatures } from '../../navigation/routingfeature';
import { TuneSettingsComponent } from '../tunesettings/tunesettingscomponent';
import { ToneStatus } from '../../../toolkit/toneoptions/tone/tonestatus';
import './mytunes-style.css';
import { PlaylistToneViewModelHandler } from '../wishlist/playlist/playlistcard/playlistviewmodel';

export class TunePlaylistOptionPrivilageImpl extends ToneRowOptionsPrivilageImpl
{
    constructor()
    {
        super();

        this.setAction(true);
        this.setSettings(true);
        this.setGift(true);
        this.setShare(true);
        this.setTellAFriend(true);
        this.setDelete(true);
    }
  
}

export class TunesViewImpl extends CRBTUIViewImpl implements TunesTabComponentHandler, PlaylistToneViewModelHandler
{
    listToneComponent:ListTonesComponent;

    private genericTabViewModel: GenericTabViewModel;
    // private gridTabRef: GenericTabComponent;
    private tonesTab: TabViewModelImpl;
    // private playlistTab: TabViewModelImpl;
    // private profileTunes: TabViewModelImpl;
    private loaderWrapperComponent:LoaderWrapperComponent;
    private popUpComponent:PopUpWrapperComponent;
    

    


    constructor(basecontext: BaseContext, uiComponentHandler: UIComponentHandler)
    {
        super(basecontext, uiComponentHandler);

        this.onDeleteClicked = this.onDeleteClicked.bind(this);
        this.onTuneSettingsSelected = this.onTuneSettingsSelected.bind(this);
        
        this.genericTabViewModel = new GenericTabViewModelImpl();
        this.tonesTab = new TunesListTabViewModelImpl(basecontext,
            basecontext.getResources().getString(Strings.tunes), new TunesToneViewModelImpl(basecontext, 
                this.onDeleteClicked,this.onTuneSettingsSelected, "40px"));

        // this.playlistTab = new PlaylistTunesTabViewModelImpl(basecontext, 
        //     basecontext.getResources().getString(Strings.playlist), new PlaylistToneViewModelImpl(offset, 
        //         basecontext,this.onDeleteClicked,this.onTuneSettingsAdded, new TunePlaylistOptionPrivilageImpl(), this));

        // this.karaokeTab = new TunesListTabViewModelImpl(basecontext,
        //         basecontext.getRerces().getString(Strings.doityourself), new DoItYouselfToneViewModelImpl(offset, basecontext, this.onDeleteClicked, this.onTuneSettingsAdded));
    
        // this.profileTunes = new ProfileTunesListTabViewModelImpl(basecontext,
        //     this.getContext().getResources().getString(Strings.profile_tunes), new ProfileTunesViewModelImpl(basecontext, this.onDeleteClicked, "40px"));
        
        this.genericTabViewModel.addTab(this.tonesTab);
        // this.genericTabViewModel.addTab(this.profileTunes);
        // this.genericTabViewModel.addTab(this.playlistTab);
    }
    
    bindHandlers()
    {
        this.closePopup = this.closePopup.bind(this);
        this.showPopup = this.showPopup.bind(this);
        this.onSettingsSuccess = this.onSettingsSuccess.bind(this);
        this.onSettingsCancel = this.onSettingsCancel.bind(this);
        this.confirmClick = this.confirmClick.bind(this);
        this.isShuffleOn = this.isShuffleOn.bind(this);
        this.showInactiveSubscriberPopup = this.showInactiveSubscriberPopup.bind(this);
    }
    
    getChildComponent(props: TunesComponentProps, state: TunesComponentState, cssStyle: TunesCSSStyle): JSX.Element
    {
        return (
            <>
                   {
                     this.getWebView(props, state, cssStyle)
                    }
                   <PopUpWrapperComponent ref={(item: any) => this.popUpComponent = item} context={props.context}/>
              <LoaderWrapperComponent ref={(item: any) => this.loaderWrapperComponent = item} context={props.context}/>

            </>
        );
    }

    getWebView(props: TunesComponentProps, state: TunesComponentState, cssStyle: TunesCSSStyle)
    {
        console.log("----props.isShuffleOn: " + state.shuffleStatus);
        return (
            <>
               {
             state.status === ToneStatus.PENDING &&
               this.showInactiveSubscriberPopup() }
             {
                state.isSettingsClicked && <TuneSettingsComponent isShuffleOn={state.shuffleStatus} toneDto={state.toneDto} onSettingsSuccess={this.onSettingsSuccess} onCancelClicked={this.onSettingsCancel} context={props.context} />}
            {
                !state.isSettingsClicked &&  (state.status !==ToneStatus.PENDING) && 
                <>

                <ListTonesComponent ref={(item: any) => this.listToneComponent = item} isShuffleOn={this.isShuffleOn} context={props.context}/>       
                <div style={cssStyle.getWrapperCSSStyle()}>
                        <GenericTabComponent onTabSelected={()=>{}} headerTitle={props.context.getResources().getString(Strings.mytunes)} initialTab={props.context.getResources().getString(Strings.tunes)} genericTabViewModel={this.genericTabViewModel} context={props.context}/>
                </div>
               
              </>
            }
            </>
        );
    }


    // getMobileView(props: TunesComponentProps, state: TunesComponentState, cssStyle: TunesCSSStyle)
    // {
    //     return (
    //         <>
    //            {
    //          state.status === ToneStatus.PENDING &&
    //            this.showInactiveSubscriberPopup() }
    //          {
    //             state.isSettingsClicked && <TuneSettingsComponent toneDto={state.toneDto} onSettingsSuccess={this.onSettingsSuccess} onCancelClicked={this.onSettingsCancel} context={props.context} />}
    //         {
    //             !state.isSettingsClicked && (state.status !==ToneStatus.PENDING) && 
    //             <>

    //             <ListTonesComponent isShuffleOn={state.shuffleStatus} context={props.context}/>       
    //             <div style={cssStyle.getWrapperCSSStyle()}>
    //                     <GenericTabComponent onTabSelected={()=>{}} headerTitle={props.context.getResources().getString(Strings.mytunes)} initialTab={props.context.getResources().getString(Strings.tunes)} genericTabViewModel={this.genericTabViewModel} context={props.context}/>
    //             </div>
               
    //           </>
    //         }
    //         </>
    //     );
    // }
    isShuffleOn(shuffleOn: boolean)
    {
        (this.getUIComponentHandler() as TunesComponentHandler).onShuffleStatus(shuffleOn);
    }

    onSettingsSuccess()
    {
        (this.getUIComponentHandler() as TunesComponentHandler).onSuccessTuneSettings(false);
    }

    onSettingsCancel()
    {
        (this.getUIComponentHandler() as TunesComponentHandler).onCloseTuneSettings(false);
    }

    onTuneSettingsSelected(toneDto: ToneDto): void 
    {
        console.log("settings click &&&&:",(toneDto as ListTonesDto).getStatus());
        
        if((toneDto as ListTonesDto).getStatus() === ToneStatus.ACCEPTED)
        {
            (this.getUIComponentHandler() as TunesComponentHandler).onTuneSettingsSelected(toneDto);

        }
        else{
            this.popUpComponent !== null && this.popUpComponent.setShowWindow(true, <AlertComponent buttonTitle={this.getContext().getResources().getString(Strings.ok)} alertMessage={this.getContext().getResources().getString(Strings.You_cannot_access_advanced_settings_for_Non_Active_tunes)} alertType={AlertType.WARN} onCloseButtonClick={this.closePopup} onClick={this.closePopup} context={this.getUIProps().context}/>);

            
        }
    }
    confirmClick()
    {
        this.dismissLoader();
        this.getUIProps().context.getRedirectionHandler().routeNextFeature(RoutingFeatures.HOME, false);
    }
    showInactiveSubscriberPopup()
    { 
        this.popUpComponent !== null && this.popUpComponent.setShowWindow(true, <AlertComponent buttonTitle={this.getUIProps().context.getResources().getString(Strings.get_tunes)} alertMessage={this.getUIProps().context.getResources().getString(Strings.you_are_not_an_active_subscriber)} alertType={AlertType.WARN} onCloseButtonClick={this.confirmClick} onClick={this.confirmClick} context={this.getUIProps().context}/>);
    }
    showLoader()
    {
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(true,  <LoaderComponent context={this.getUIProps().context}/>);   
    }
  
    dismissLoader()
    { 
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(false, <></>);
    }

    getNavigationPath()
    {
        return  [this.getUIProps().context.getResources().getString(Strings.myaccount),
            this.getUIProps().context.getResources().getString(Strings.mytunes)];

        // return !(this.getUIState() as TunesComponentState).isSettingsClicked ?
        //  [this.getUIProps().context.getResources().getString(Strings.myaccount),
        //      this.getUIProps().context.getResources().getString(Strings.mytunes)]
        //      :
        //       [this.getUIProps().context.getResources().getString(Strings.myaccount),
        //                  this.getUIProps().context.getResources().getString(Strings.mytunes), 
        //                  this.getUIProps().context.getResources().getString(Strings.advance_setting)];
    }

    getBannerImg()
    {
        return "mytunes.jpg";
    }
    

    updateTonesData(listToneDto: ToneDto[])
    {
        (this.tonesTab as TunesListTabViewModelImpl).updateTabData(listToneDto.filter((toneDto: ToneDto)=>
        {
           
            return !(toneDto as ListTonesDto).getIsStatusRBT();
        }));
    
        // (this.profileTunes as TunesListTabViewModelImpl).updateTabData(listToneDto.filter((toneDto: ToneDto)=>
        // {
        //     return (toneDto as ListTonesDto).getIsStatusRBT();
        // }));
    }

    showPopup(msg:string,type:AlertType):void
    {
        this.closePopup();

        if(type === AlertType.WARN)
        {
            this.popUpComponent !== null && this.popUpComponent.setShowWindow(true, <AlertComponent buttonTitle={this.getContext().getResources().getString(Strings.ok)} alertMessage={msg} alertType={type} onCloseButtonClick={this.closePopup} onClick={this.closePopup} context={this.getUIProps().context}/>);
            
        }
        this.popUpComponent !== null && this.popUpComponent.setShowWindow(true, <AlertComponent buttonTitle={this.getContext().getResources().getString(Strings.ok)} alertMessage={msg} alertType={type} onCloseButtonClick={this.confirmClick} onClick={this.confirmClick} context={this.getUIProps().context}/>);
        
    }
    // updatePlaylistData(tonedto: ToneDto[])
    // {
    //     console.log("settings playlist data2");
    //     (this.playlistTab as PlaylistTunesTabViewModelImpl).updateTabData(tonedto);
    // }
    closePopup()
    {
        this.popUpComponent !== null && this.popUpComponent.setShowWindow(false, <></>);
    }
    updateKaraokeData()
    {
        // (this.karaokeTab as TunesListTabViewModelImpl).updateTabData(tonedto);
    }

    updateProfileTunesData()
    {
        //  (this.profileTunes as TunesListTabViewModelImpl).updateTabData(tonedto);
    }

    onLoadMore(startIndex: number, offset: number, searchKey: string): void 
    {
       (this.getUIComponentHandler() as TunesComponentHandler).onLoadMore(this.genericTabViewModel.getSelectedTabTitle(), 
       startIndex, offset, searchKey);
    }

    onPlaylistSelected(playlistdto: ToneDto): void 
    {
        (this.getUIComponentHandler() as TunesComponentHandler).onPlaylistSelected(playlistdto);
    }

    onDeleteClicked(toneDto: ToneDto): void 
    {
        if(this.genericTabViewModel.getSelectedTabTitle() === this.getUIProps().context.getResources().getString(Strings.tunes))
        {
            this.tonesTab.deleteData(toneDto.getId());
            this.listToneComponent.refreshList();
        }
        // else if(this.genericTabViewModel.getSelectedTabTitle() === this.getUIProps().context.getResources().getString(Strings.profile_tunes))
        // {
        //     this.profileTunes.deleteData(toneDto.getId());
        // }
        // else{
        //     this.playlistTab.deleteData(toneDto.getId());
        // }
    }

    // updateTab()
    // {
    //     this.gridTabRef.onTabSelected("Tunes");
    // }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/tunes/tunesview.tsx